// extracted by mini-css-extract-plugin
export default {"changePriceContainer":"monetization_changePriceContainer__RRHta","btn":"monetization_btn__hBdMY"};